import React from 'react';
import ActiveUsersChart from "../../../components/pages/chart/ActiveUsersChart/ActiveUsersChart";

const ActiveUsersChartPage = () => {
    return <ActiveUsersChart />
};

export default ActiveUsersChartPage;